var apis = require("../apis");
var _const = require("@/common/const");
var container_tpl = require("./indexTpl.html");
var item_tpl = require("./itemTpl.html");
var SELFSERVICE_PATH = _const.SELFSERVICE_PATH;

module.exports = function(){
	var container = $(_.template(container_tpl)());

	apis.getSelfServiceList()
	.then(function(data){
		_.each(data, function(item){
			if(item.iconType == "system"){
				item.icon = SELFSERVICE_PATH + item.icon;
			}
		});
		container.removeClass("hide");

		console.log(data)
		container.append(_.template(item_tpl)({
			selfService: data
		}));
		$(".right_service_href_cls").on("click", function(e){
			console.log($(this).attr("id"))
			var id = $(this).attr("id");
			apis.recordFaqClick(id,"self-service");
		})
	});

	// APIs
	this.$el = container;
	this.show = function(){
		
	};
};



//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/q&a/selfService/index.js
// module id = 252
// module chunks = 0